module.exports = __webpack_public_path__ + "img/azali.cde82465.svg";